import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  backTypes: { data: [], raw: [], loading: false },
  entityTypes: { data: [], raw: [], loading: false },
  flagImageTypes: { data: [], raw: [], loading: false },
  filterTypes: { data: [], raw: [], loading: false },
  materialFullTypes: { data: [], raw: [], loading: false },
  materialTypes: { data: [], raw: [], loading: false },
  statusTypes: { data: [], raw: [], loading: false },
  surfaceTypes: { data: [], raw: [], loading: false },
  unitTypes: { data: [], raw: [], loading: false },
  luminorConfigTypes: { data: [], raw: [], loading: false },
  dialogPrice: { visible: false, loading: false, data: null },
  dialogExport: { visible: false, loading: false, data: null },
  dialogImport: { visible: false, loading: false, data: null },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
